import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import {
  formDictionary,
  TemplatesProvider,
} from '@unlikelystudio/react-ecommerce-hooks'

import SquaredCta from '~/components/UI/SquaredCta'

import { FORM } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type TemplateProviderProps = Parameters<typeof TemplatesProvider>[0]

export type FormTemplateProps = TemplateProviderProps & {
  className?: string
}

function FormTemplate({
  className,
  dictionary,
  components,
  children,
}: FormTemplateProps) {
  const t = useTranslate()

  const processedDictionary = Object.keys(dictionary)?.reduce((acc, lang) => {
    return {
      ...acc,
      [lang]: {
        ...dictionary[lang],
        acceptsMarketing: t(FORM.ACCEPT_MARKETING),
      },
    }
  }, {})

  return (
    <div className={cx(className, css.FormTemplate)}>
      <TemplatesProvider
        dictionary={processedDictionary}
        components={{
          input: (props) => {
            if (props?.type === 'submit') {
              return (
                <SquaredCta
                  className={css.submit}
                  type="submit"
                  theme={GlobalThemeColors.Black}
                  withBackground
                  textPreset={GlobalTextPreset.Cta12Grotesk}>
                  {props?.value}
                </SquaredCta>
              )
            }

            return null
          },
          ...components,
        }}>
        {children}
      </TemplatesProvider>
    </div>
  )
}

FormTemplate.defaultProps = {
  dictionary: formDictionary,
  components: {},
}

export default FormTemplate
